/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Chat session properties that can be used for sorting.
 */
export var ChatSessionPropertiesForSorting;
(function (ChatSessionPropertiesForSorting) {
    ChatSessionPropertiesForSorting["CHAT_ID"] = "chatId";
    ChatSessionPropertiesForSorting["CHAT_TITLE"] = "chatTitle";
    ChatSessionPropertiesForSorting["LAST_UPDATED"] = "lastUpdated";
})(ChatSessionPropertiesForSorting || (ChatSessionPropertiesForSorting = {}));
